import { OfficeWorkload } from '@office-start/officehome-types';
/**
 * New User Tui Items
 */
export var NewUserUploadTuiItem = {
    id: 'ConsumerUploadTuiItem',
    type: 'item',
    callout: 'Upload_Content_Callout',
};
export var NewUserAllSetTuiItem = {
    id: 'ConsumerAllSetTuiItem',
    type: 'item',
    callout: 'All_Set_Callout',
    activationSettings: {
        workloads: [OfficeWorkload.OfficeHome, OfficeWorkload.OfficeHomeReact],
    },
};
//# sourceMappingURL=tui-items.js.map